import { Shop } from 'modules/Shop/model/types'
import { ShopCard } from 'modules/Shop/ui/ShopCard/universal'

import { Section } from 'shared/ui/section'

import styles from './ShopList.module.scss'

interface ShopListProps {
  shops: Shop[]
  title: string
}

export function ShopList({ shops, title }: ShopListProps) {
  if (!shops.length) return null

  return (
    <div className={styles.wrapper}>
      <Section title={title}>
        <div className={styles.list}>
          {shops.map(({ id, slug, catalog_image, name }) => (
            <ShopCard key={id} slug={slug} logo={catalog_image} name={name} />
          ))}
        </div>
      </Section>
    </div>
  )
}
